import * as React from "react";
import styled from "../../../styled/index";
const ContentComponent = styled("div") `
  margin: 0 auto;
  width: 100%;
  max-width: ${({ width, theme }) => width === "full" ? "100%" : `${theme.content_width[width]}px`};
`;
export const Content = (props) => React.createElement(ContentComponent, Object.assign({}, props));
//# sourceMappingURL=index.js.map